import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Fishermans Bend – Sewer Mining Pump Station</h3>
      </div>
      <div className="popup-content-source">
        <p className="bold">
          We'll design and construct a Sewer Mining Pump Station to extract the city’s wastewater to supply the Fishermans Bend Water Recycling Plant (WRP), so that it can be treated to class A recycled water. 
        </p>
        <p>
          We’ve worked with Melbourne Water to install an offtake and waste return structure to their Hobsons Bay main sewer that will enable South East Water to connect to the Fishermans Bend WRP in the future. 
        </p>
        <p>
          For more project information click{' '}
          <a
            href="https://southeastwater.com.au/faults-and-works/works/projects/fishermans-bend/"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map – Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MORE INFO: Fishermans Bend - Sewer Mining Pump Station',
              });
            }}
          >
            here
          </a>{' '}
          or contact the project team at{' '}
          <a href="tel:1800055465">1800 055 465</a> |{' '}
          <a
            href="mailto:FishermansBend@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map – Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MAIL TO: FishermansBend@sew.com.au - Fishermans Bend - Sewer Mining Pump Station',
              });
            }}
          >
            FishermansBend@sew.com.au
          </a>
        </p>
      </div>
    </>
  );
};

export default Content;
